import { motion } from "framer-motion"
import logo from "./user.jpg";
import logo1 from "./training.jpg";
import logo2 from "./feedback.jpg";

export  function Framermotionnivas() {
  return (
    <div>
        
      <motion.div style={{float:'left',display:'inline-block',marginTop:"20px",}}>
      
        
     <motion.ul>
     
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>All Students</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
        <h6 style={{marginTop:"-25px",color:"black"}}>Class 5-A</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 5-B</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 6-A</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     
     <h6 style={{marginTop:"-25px",color:"black"}}>Class 6-B</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 7-A</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 7-B</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     

     <h6 style={{marginTop:"-25px",color:"black"}}>Class 7-C</h6>
      </motion.li>
     
      <br></br>
     <br></br>
     <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 8-A</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     
     <h6 style={{marginTop:"-25px",color:"black"}}>Class 8-B</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 9-A</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 9-B</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     

     <h6 style={{marginTop:"-25px",color:"black"}}>Class 10-A</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 10-B</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 11-A</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     <h6 style={{marginTop:"-25px",color:"black"}}>Class 11-A(BPC)</h6>
      </motion.li>
     <br></br>


     <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 11-A(MPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     
     <h6 style={{marginTop:"-25px",color:"black"}}>Class 11-B</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 11-B(BPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 12-A</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     

     <h6 style={{marginTop:"-25px",color:"black"}}>Class 12-A(0)</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 12-A(BPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 12-A(MPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     <h6 style={{marginTop:"-25px",color:"black"}}>Class 12-B</h6>
      </motion.li>
     
<br></br>
<motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
<br></br>
<h6 style={{marginTop:"-30px",color:"black"}}>Class 12-B(BPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     
     <h6 style={{marginTop:"-25px",color:"black"}}>Class 13-A(BPC)</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 13-A(MPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Class 13-B(BPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#f7f4c8",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
     

     <h6 style={{marginTop:"-25px",color:"black"}}>Class 14-A(BPC)</h6>
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#a4e5f5",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>
      <h6 style={{marginTop:"-25px",color:"black"}}>Class 14-A(MPC)</h6>
     
      </motion.li>
      <motion.li  whileHover={{ scale: 1.2 }} whileTap={{ scale: 0.8 }} style={{ backgroundColor:"#c7f2cf",height:"10px",width:"120px"
      ,padding:'40px 20px 20px 15px', marginBottom: '5px',float:'left'
    }}>

<h6 style={{marginTop:"-25px",color:"black"}}>Guest</h6>
     
      </motion.li>
      
     </motion.ul>
     </motion.div>


    </div>
  )
}